import React from 'react';

import { Table } from 'semantic-ui-react';

import { formatPercent } from '../../../../utils/format_helpers';

export const PercentCell = ({ item, col }) => {
  const value = item[col.key];
  return (
    <Table.Cell>
      {`${formatPercent(Math.abs(value))} ${value > 0 ? 'increase' : 'decrease'}`}
    </Table.Cell>
  );
};

const createDescription = item => {
  const {
    'pixel_anomaly.action': action,
    'pixel_anomaly.anomaly_type': type,
    'pixel_anomaly.metric_delta': delta,
    'pixel_anomaly.metric': impacted_variable,
  } = item;
  const anomalyTypes = ['overall_pixel_volume_decrease', 'Non-Null Variable Decrease', 'Overall Pixel Volume Decrease']; // replace with correct types

  if (!anomalyTypes.includes(type)) return `Your ${action} pixel was found to be anomalous in the past hour.`;

  if (type === 'overall_pixel_volume_decrease' || type === 'Overall Pixel Volume Decrease') {
    return `Your ${action} pixel volume ${delta > 0 ? 'increased' : 'decreased'} by ${formatPercent(Math.abs(delta))} in the past hour compared to the same hour and day of week over the past 4 weeks.`; // eslint-disable-line max-len
  }

  if (type === 'Non-Null Variable Decrease') {
    return `The percent of ${action} pixels passing non-null ${impacted_variable} variables ${delta > 0 ? 'increased' : 'decreased'} ${formatPercent(Math.abs(delta))} in the past hour compared to the past 24 hours.`; // eslint-disable-line max-len
  }

  return `Your ${action} pixel was found to be anomalous in the past hour.`;
};

export const DescriptionCell = ({ item }) => {
  const description = createDescription(item);
  return (
    <Table.Cell>
      {description}
    </Table.Cell>
  );
};
